const jQ = jQuery.noConflict();
const body = jQ('body');
const icon = jQ('.community__icon');
const nav = jQ('.community__nav');


function toggleMenu() {
    jQ(this).addClass('active');
    nav.toggleClass('active');
    if (nav.hasClass('active')) {
        nav.slideDown('easy');
    } else {
        nav.slideUp('easy', () => {
            icon.removeClass('active');
        });
    }
}

function initToggle() {
    jQ(window).on('click', (e) => {
        if (nav.hasClass('active')) {
            if ((jQ(e.target).parents('.community__wrapper').length == 0)) {
                toggleMenu();
            }
        }
    });
    icon.on('click', toggleMenu);
}


export default initToggle;
